import { embedDemoHtml } from './embedDemo';
import { lineupDemoHtml } from './lineupDemo';

export type PreviewTemplate = {
	id: string;
	label: string;
	html: string;
};

export const PREVIEW_TEMPLATES: PreviewTemplate[] = [
	{ id: 'lineup', label: 'Stern Grove lineup (mock Squarespace page)', html: lineupDemoHtml },
	{ id: 'embed_demo', label: 'Embed demo (basic)', html: embedDemoHtml },
];

const SCRIPT_PLACEHOLDER = '{{EMBED_SCRIPT}}';

export const renderPreviewTemplate = (template: PreviewTemplate, minifiedScript: string): string =>
	template.html.replace(SCRIPT_PLACEHOLDER, minifiedScript);
